<template>
  <div
    class="card-bolao card-bolao--default"
    v-if="item && renderComponent && itemType == 'default'"
    v-bind:class="{ ['lot-' + item.lottery.slug]: true }">
    <div class="card-bolao__lot-head lot-bg" v-if="showLotHead && item.lottery">
      <span>{{ item.lottery.name }}</span>
    </div>

    <header>
      <div class="text-center">
        <div>Bolão</div>
        <div><strong v-text="item.domain"></strong></div>
      </div>
      <div class="text-center">
        <strong class="lot-color" v-text="item.unitPriceText"></strong>
      </div>
    </header>

    <div class="card-bolao__info-1">
      <div class="text-center">
        <div>Prêmio</div>
        <div class="lot-color">
          <strong
            v-text="
              item.nextDraw ? item.nextDraw.estimatedPrizeText : 'A Definir'
            "></strong>
        </div>
        <div
          class="card-bolao__is-jackpot"
          v-if="item.nextDraw && item.nextDraw.isJackpot">
          <i class="fa fa-star"></i> <span>Acumulada!</span>
        </div>
      </div>

      <div class="card-bolao__chances">
        <div class="card-bolao__chances-block">
          <div
            v-text="item.moreChances ? item.moreChances + 'x' : '---x'"></div>
          <strong>+chances</strong>
        </div>
      </div>

      <div>
        <button
          class="btn btn-icon btn-white lot-bg-hover color-white-hover"
          v-on:click="viewGame(item)">
          <i class="fa fa-eye"></i>
        </button>
      </div>
    </div>

    <div class="card-bolao__info-2">
      <div class="text-center">
        Opção de Jogo: <big><strong v-text="item.serie"></strong></big>
      </div>

      <div class="text-center">
        Total:
        <span
          v-text="
            item.units + ' ' + (item.units == 1 ? 'cota' : 'cotas')
          "></span>
      </div>

      <div class="text-center">
        <strong>
          Disponíveis:
          <span
            class="lot-color"
            v-text="
              item.unitsInStock +
              ' ' +
              (item.unitsInStock == 1 ? 'cota' : 'cotas')
            "></span>
        </strong>
      </div>
    </div>

    <footer>
      <div class="card-bolao__qty lot-bg lot-bg-dark-hover">
        <div class="card-bolao__qty__control">
          <button :disabled="item.isupdating" v-on:click="setUnits('-')">
            <span>-</span>
          </button>
          <input
            type="tel"
            value="0"
            maxlength="4"
            :disabled="item.isupdating"
            :key="item.productName"
            v-model="item.myUnits"
            v-on:keyup.enter="setUnits(item.myUnits, true)"
            v-on:blur="setUnits(item.myUnits)" />
          <button :disabled="item.isupdating" v-on:click="setUnits('+')">
            <span>+</span>
          </button>
        </div>
        <button
          class="card-bolao__btn-add"
          v-on:click="setUnits('+')"
          :disabled="item.isupdating"
          v-bind:class="['btn-lot-' + item.lottery.slug]">
          <span class="icon"></span>
          <span class="label d-lg-none">Adicionar</span>
          <span class="label d-none d-lg-inline">Adicionar ao carrinho!</span>
        </button>
      </div>
    </footer>
  </div>

  <div
    class="card-bolao card-bolao--bar"
    v-else-if="item && renderComponent && itemType == 'bar'"
    v-bind:class="{ ['lot-' + item.lottery.slug]: true }">
    <div class="card-bolao__lot-head lot-bg" v-if="showLotHead && item.lottery">
      <span class="text-left">{{ item.lottery.name }}</span>
      <span class="text-center">
        <div
          class="card-bolao__is-jackpot"
          v-if="item.nextDraw && item.nextDraw.isJackpot">
          <i class="fa fa-star"></i> <span>Acumulada!</span>
        </div>
      </span>
      <span
        class="text-right"
        v-text="
          item.nextDraw ? item.nextDraw.estimatedPrizeText : 'A Definir'
        "></span>
    </div>

    <header>
      <div class="text-left">
        <strong v-text="item.domain"></strong>
        <small v-text="item.serie"></small>
      </div>
      <div class="text-center">
        <strong class="lot-color" v-text="item.unitPriceText"></strong>
      </div>
      <div>
        <button
          class="btn btn-icon btn-white lot-bg-hover color-white-hover btn-small"
          v-on:click="viewGame(item)">
          <i class="fa fa-eye"></i>
        </button>
      </div>
      <div>
        <button
          class="card-bolao__btn-add-mini btn btn-square"
          v-on:click="setUnits('+')"
          :disabled="item.isupdating"
          v-bind:class="['btn-lot-' + item.lottery.slug]">
          <span class="icon"></span>
        </button>
      </div>
    </header>
  </div>

  <div
    class="card-bolao-circle"
    v-else-if="item && renderComponent && itemType == 'circle'"
    v-bind:class="{ ['lot-' + item.lottery.slug]: true }">
    <button
      class="btn btn-icon btn-white lot-bg-hover color-white-hover"
      v-on:click="viewGame(item)">
      <i class="fa fa-eye"></i>
    </button>

    <div class="card-bolao-circle__body lot-bg">
      <div class="card-bolao-circle__text">
        <div
          class="card-bolao-circle__text__chances"
          v-text="item.moreChances ? item.moreChances + 'x' : '---x'"></div>
        <div class="card-bolao-circle__text__chances-label">+ chances</div>
        <div class="card-bolao-circle__text__price">
          por <span>{{item.unitPriceText}}</span>
        </div>
        <div class="card-bolao-circle__text__units">
          Cotas disponíveis
          <span>{{`${(item.unitsInStock + '').padStart(2, '0')}/${(item.units + '').padStart(2, '0')}`}}</span>
        </div>
      </div>
      <div class="card-bolao-circle__image"></div>
    </div>

    <button
      class="card-bolao__btn-add"
      v-on:click="setUnits('+')"
      :disabled="item.isupdating"
      v-bind:class="['btn-lot-' + item.lottery.slug]">
      <span class="icon"></span>
      <span class="label" v-text="itemLabelAddCart"></span>
    </button>
  </div>
</template>
<style src="./CardBolao.scss" scoped/>
<script>
import CartApi from '../../Api/CartApi';

export default {
  props: {
    itemData: null,
    showLotHead: {
      type: Boolean,
      default: false
    },
    itemType: {
      type: String,
      default: 'default',
      validator: (val) => {
        return ['default', 'bar', 'circle'].indexOf(val) !== -1;
      }
    },
    itemLabelAddCart: {
      type: String,
      default: 'Adicionar ao carrinho!'
    }
  },
  data: function () {
    return {
      pendingAdd: null,
      processing: false,
      item: null,
      shoppingCartItemID: false,
      renderComponent: true
    };
  },
  methods: {
    forceRerender () {
      this.viewComponent = false;
      this.$nextTick(() => {
        this.viewComponent = true;
      });
    },
    viewGame () {
      try {
        Modal.open('JOGO', {
          productID: this.item.id,
          drawNumber: this.item.drawNumber,
          lotteryID: this.item.lotteryID || null
        });
      } catch (err) {
        console.error(err);
      }
    },
    setUnits (newUnits, isImmediately = false) {
      const qty = this.item.myUnits;

      if (newUnits == '+') {
        newUnits = qty + 1;
      }
      if (newUnits == '-') {
        newUnits = qty - 1;
      }
      if (isNaN(parseInt(newUnits))) {
        newUnits = this.item.myUnits;
      }

      newUnits = parseInt(newUnits);

      if (!newUnits) {
        newUnits = 0;
      }
      if (newUnits > this.item.unitsInStock) {
        newUnits = this.item.unitsInStock;
      }

      if (newUnits <= this.item.unitsInStock && newUnits >= 0) {
        this.item.myUnits = newUnits;
      }

      if (this.pendingAdd) {
        clearTimeout(this.pendingAdd);
      }

      if (this.item.myUnits == 0 || isImmediately) {
        this.addGame(false);
      } else {
        const _self = this;

        this.pendingAdd = setTimeout(function () {
          _self.addGame(false);
        }, 1000);
      }

      this.forceRerender();
    },
    applyCart (cart) {
      const cartItems = cart
        ? cart.items.filter(
          (a) => a.categoryID == 1 && a.productName == this.item.productName
        )
        : [];

      this.item.myUnits =
        cartItems && cartItems.length ? cartItems[0].unitsAcquired : 0;
      this.shoppingCartItemID =
        cartItems && cartItems.length ? cartItems[0].shoppingCartItemID : null;

      this.forceRerender();
    },
    addGame (increase = true) {
      if (this.pendingAdd) {
        clearTimeout(this.pendingAdd);
      }
      if (this.processing) {
        return;
      }

      if (increase && this.item.myUnits == 0) {
        this.item.myUnits = this.item.myUnits + 1;
      }

      let prom = null;
      const tracking = {
        name: this.item.domain,
        price: this.item.unitPriceText,
        category: this.item.lottery.name,
        variant: this.item.serie,
        quantity: this.item.myUnits
      };

      if (this.shoppingCartItemID) {
        prom = CartApi.update(this.shoppingCartItemID, this.item.myUnits, true, this.item.lotteryID);
      } else {
        prom = CartApi.add(
          this.item.inventoryId,
          this.item.myUnits,
          true,
          tracking,
          this.item.lotteryID == 13
        );
      }

      this.processing = true;

      prom
        .then(() => {
          this.$toast.open({
            message: 'Itens atualizados.'
          });
        })
        .catch((err) => {
          this.$toast.open({
            type: 'error',
            message:
              err && err.message ? err.message : 'Erro ao tentar atualizar.'
          });
        })
        .then(() => {
          CartApi.updateCart();
          this.processing = false;
        });
    }
  },
  created () {
    const _self = this;

    if (!this.itemData) {
      return;
    }

    _self.item = JSON.parse(JSON.stringify(this.itemData));
    _self.item.myUnits = 0;

    CartApi.getItems().then((res) => {
      _self.applyCart(res);
    });

    window.addEventListener('cart:update', function (e) {
      _self.applyCart(e.detail);
    });
  }
};
</script>
